import React from "react"
import {useEffect} from "react"

import {useUserApp} from "@hooks"
import { teardownIris } from "@utils/irisStorage"


export default function LogoutPage() {
	const { handleLogout } = useUserApp()

	useEffect(() => {
		// Iris first: her drawer is outside React and must not outlive the session (CU-869fmq2bf, Curro 2026-10-28).
		// `PmsAgentWidget`'s cleanup already did this when the app layout unmounted; this is the net if it did not
		teardownIris(window)
		handleLogout()
	}, [])

	return <></>
}